
import React, { useRef, useState, useEffect } from 'react';
import './Section3.css';
import img1 from './phone1.png';
import img2 from './phone2.png';
import img3 from './phone3.png';
import img4 from './phone4.png';


const content = [
  {
    title: '📱Easy Onboarding',
    desc: 'Sign up instantly using your work email—no extra steps, no friction.',
    image: img1,
  },
  {
    title: '📊Track CO₂ Footprint',
    desc: 'Get a clear view of personal and company-wide emissions in real time.',
    image: img2,
  },
  {
    title: '🏆Gamified Challenges',
    desc: 'Turn eco-friendly habits into daily missions and earn coins, badges, and levels.',
    image: img3,
  },
  {
    title: '📥Monthly ESG Reports',
    desc: 'Automatically generate ESG-ready reports with participation and CO₂ reduction data.',
    image: img4,
  },
];

const Section3 = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const refs = useRef([]);

  useEffect(() => {
    const scrollArea = document.querySelector('.points-scroll-wrapper');
    const sectionRef = document.querySelector('.section3');
  
    // Observer for updating activeIndex based on visible point
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveIndex(Number(entry.target.dataset.index));
          }
        });
      },
      {
        root: scrollArea,
        threshold: 0.6,
      }
    );
  
    refs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });
  
    // Function to check if section is in viewport
    const isInViewport = () => {
      const rect = sectionRef.getBoundingClientRect();
      return rect.top >= 0 && rect.bottom <= window.innerHeight;
    };
  
    // Auto-scroll only when section is visible
    const interval = setInterval(() => {
      if (isInViewport()) {
        setActiveIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % content.length;
          refs.current[nextIndex]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
          return nextIndex;
        });
      }
    }, 2000);
  
    return () => {
      refs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
      clearInterval(interval);
    };
  }, []);
  
  
  return (
    <div className="section3">
      <div className="left">
        <div className="image-box-app">
          <img src={content[activeIndex].image} alt="Preview" />
        </div>
      </div>

      <div className="right">
         <div className="problem-tag">🔥OUR SOLUTION</div>
        <h2>
          We Make Sustainability<br /><span className="highlight">Engaging & Traceable</span>
        </h2>

        <div className="points-scroll-wrapper">
          <div className="points">
            {content.map((item, index) => (
              <div
                key={index}
                ref={(el) => (refs.current[index] = el)}
                data-index={index}
                className={`point ${activeIndex === index ? 'active' : ''}`}
              >
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section3;
